import React from "react";
import SubCategoria from "./components/SubCategoria";
import { useNavigate } from "react-router-dom";

export default function UniversalTarjetaCurso({
  vIdCurso = 0,
  categorias = [],
  nombreCurso = "",
  precioCurso = "",
  numTotalLecciones = "",
  numTotalHoras = "",
  vStyleCustom = "",
  vTipoRol = "publico",
}) {
  const mRenderCategoria = () => {
    if (categorias?.length > 0) {
      return categorias.map((vCategoria, vIndex) => (
        <SubCategoria key={vCategoria.id} vCategoria={vCategoria} />
      ));
    }
    return <></>;
  };

  const vNavigate = useNavigate();

  const mSeleccionRol=()=>{
    if(vTipoRol==="publico"){
      vNavigate(`/curso-no-comprado/${vIdCurso}`)
    }else if(vTipoRol==="alumno"){
      vNavigate(`?f=cnc&curso_id=${vIdCurso}`)
    }else{
      return "curso-no-comprado"
    }
  }

  return (
    <div
      data-figma-id="115:9244"
      class="curso"
      key={vIdCurso}
      onClick={mSeleccionRol}
    >
      <div data-figma-id="115:9264" class="curso-imagen">
        <div data-figma-id="115:9265" class="curso-precio">
          <p data-figma-id="115:9266" class="curso-precio-numero">
            ${precioCurso}
          </p>
        </div>
      </div>
      <div data-figma-id="115:9246" class="curso-contenido">
        <div data-figma-id="115:9247" class="curso-header">
          <div data-figma-id="115:9248" class="curso-titulo-area">
            <div class="areas-box">{mRenderCategoria()}</div>
            <div data-figma-id="115:9250" class="curso-titulo-favorito">
              <p
                data-figma-id="115:9251"
                class="curso-titulo-texto truncate-3-line"
              >
                {nombreCurso}
              </p>
              <div data-figma-id="115:9271" class="boton-corazon">
                <div data-figma-id="115:9275" class="corazon">
                  <img
                    src="images/01-align-center.svg"
                    data-figma-id="115:9276"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-figma-id="115:9253" class="curso-lecciones-horas">
          <p data-figma-id="115:9254" class="curso-lecciones-texto">
            {numTotalLecciones} Lecciones
          </p>
          <img src="images/circle-small-1.svg" data-figma-id="115:9269" />
          <p data-figma-id="115:9256" class="curso-horas-texto">
            {numTotalHoras} Horas
          </p>
        </div>
      </div>
    </div>
  );
}
